import React, { FC } from 'react';
import Svg from '@styles/icons/svg';
import { scale } from '@components/frame';

interface DashboardDropdownSelectedIconProps {}

const DashboardDropdownSelectedIcon: FC<DashboardDropdownSelectedIconProps> = () => {
  return <Svg icon="check" color="System/Light/Blue" width={scale(15)} height={scale(15)} />;
};

export default DashboardDropdownSelectedIcon;
